import React from 'react';
import './Header.css';
import NavLinks from '../Comman/Nav';

const Header = () => {
  return (
    <header>
      <h3 className='header_logo'>نجيب محفوظ</h3>
      <nav className="nav">
      <ul className="nav__list">
  <NavLinks text="الرئيسية" to="/" className="nav_circle" />
  <NavLinks text="من هو" to="/about" />
  <NavLinks text="أعماله الأدبية" to="/works" />
  <NavLinks text="الإنجازات" to="/achievements" />
     </ul>
      </nav>
    </header>
  );
}

export default Header;